import TabListExtraMenu from './TabListExtraMenu';

export default TabListExtraMenu;
